import React from "react";
import { observer } from "mobx-react";
import { AlertRuleCreateStore } from "../../store";
import { AlertRuleCreateForm } from "./AlertRuleCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AlertRuleCreateProps = {
  alertRuleCreateStore: AlertRuleCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AlertRuleCreate: React.FC<AlertRuleCreateProps> = observer(
  ({ alertRuleCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={alertRuleCreateStore.isSaving} />
        <AlertRuleCreateForm
          alertRuleCreateStore={alertRuleCreateStore}
          alertTypeError={alertRuleCreateStore.errors.alertType?.message}
          onAlertTypeChange={(value: string) => {
            alertRuleCreateStore.setAlertTypeValue(value);
          }}
          alertType={alertRuleCreateStore.entityValues.alertType}
          enabledError={alertRuleCreateStore.errors.enabled?.message}
          onEnabledChange={(value: boolean) => {
            alertRuleCreateStore.setEnabledValue(value);
          }}
          enabled={alertRuleCreateStore.entityValues.enabled}
          paramsError={alertRuleCreateStore.errors.params?.message}
          onParamsChange={(value: string) => {
            alertRuleCreateStore.setParamsValue(value);
          }}
          params={alertRuleCreateStore.entityValues.params}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={alertRuleCreateStore.isProcessing}
          onSave={() => alertRuleCreateStore.saveNewAlertRule()}
          onCancel={() => alertRuleCreateStore.cancelNewAlertRule()}
        />
        <ErrorDialog
          open={alertRuleCreateStore.errorDialogOpened}
          title={alertRuleCreateStore.errorTitle}
          description={alertRuleCreateStore.errorDescription}
          onClose={() => alertRuleCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
